import {Component, ElementRef, HostListener, Input, OnInit, ViewChild, ViewEncapsulation, SimpleChanges} from '@angular/core';
import {EmitterService} from '../../service/EmitterService';
import {_} from 'underscore';
import {environment} from '../../../environments/environment';
import * as moment from 'moment';
import {MatDialog} from '@angular/material';
import {ExportDialogComponent} from './export-dialog/export-dialog.component';
import {HierarchyTreeComponent} from '../hierarchy-tree/hierarchy-tree.component';
import {TrainingTreeComponent} from '../training-tree/training-tree.component';
import { ActivatedRoute } from '@angular/router';
import { HierarchyService } from '../../service/hierarchy.service';
import { TODAY } from '../../model/commons/DateConstants';
import {RoleService} from '../../service/RoleService';

@Component({
  selector: 'app-intelcia-tree',
  templateUrl: './intelcia-tree.component.html',
  styleUrls: ['./intelcia-tree.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class IntelciaTreeComponent implements OnInit {
  public _data: any;
  _search: any = true;
  _sort: any = true;
  _sortStyle: any = {transform: 'rotateX(0deg)', transition: 'all .5s'};
  _isSorted: any = false;
  _h: any;
  _nodes: any = [];
  _nodesT: Array<any> = [];
  _nodesTmp: any;
  _sites: any;
  _prevId: any;
  _onactive: any;
  ProgressState = false;
  isEmpty = false;
  _allItem = false;
  ContextMenuToggle = false;
  ContextMenuStyle = {'position': 'absolute', 'top': '0', 'left': '0'};
  filterEnd: any = null;
  filterEndName: any = 'noend';
  _checkExport = false;
  picture: string = "https://myshift2.intelcia.com/api/teams/picture?username=";
  @ViewChild('query') public query: ElementRef;
  public _isInActive = false;
  public _isActive = false;
  public _isMainTL = false;
  public _isBackupTL = false;
  public _isMutualTL = false;
  public _tls: any = [];
  public _isShowAllTls = false;
  public _isShowIconAllTls = true;
  isDS : boolean = false;
  constructor(private eventEmit: EmitterService, public dialog: MatDialog,  private hierarchyTreeComponent: HierarchyTreeComponent,
              private trainingTreeComponent: TrainingTreeComponent, private hierarchyService: HierarchyService, private route: ActivatedRoute,private roleService:RoleService) {
  }

  ngOnInit() {
    this.isDS = this.roleService.isDS;
  }
  @HostListener('click', ['$event']) click(event?) {
    this.ContextMenuToggle = false;
  }

  @HostListener('contextmenu', ['$event']) contextmenu(event?) {
    if (!environment.debug.menu) {
      return false;
    }
    const classes = event.toElement.getAttribute('class').split(' ').indexOf('mat-list-item-content');
      if ( classes > -1) {
        this.ContextMenuToggle = true;
        this.ContextMenuStyle.top  = event.clientY + 'px';
        const left = Math.abs(event.clientX - event.toElement.offsetWidth);
        this.ContextMenuStyle.left =  (left < 10 ? '10' : left + 'px');
      } else {
        this.ContextMenuToggle = false;
      }
    return false;
  }
  @Input() public set search(v: any) { this._search = v; }
  @Input() public set sort(v: any) { this._sort = v; }
  @Input() public set onNodes(v: any) {  this._onactive = v; }
  @Input() public set nodes(v: any) {
    this._data = v;
    this.PrepareParentId();
    this.ProgressLoad(() => {
      this._nodes = this.TreeItems();
      this.route.queryParamMap.source.subscribe(res => {
        if(res.usernameVerrou){
          this.getNodes(this._nodes && this._nodes[0].id, null, null, null);
        }
      });
    });
  }
  public ExportNodes() {
    const sites = this.trainingTreeComponent.sites.concat(this.hierarchyTreeComponent.sites)
    let dialogRef = this.dialog.open(ExportDialogComponent, {
      width: '750px',
      data: { sites }
    });

  }
  private isAll() {
    const d = _.unique(_.pluck(this._nodesTmp, 'parentId'));
    const a = _.unique(_.pluck(this._nodesTmp, 'parent'));
    const all = this._data.filter(e => e.parent === a[0] || e.id === a[0]);
    return {data: all, status: this._allItem = d[0] !== undefined };
  }
  public AllNodes() {
    const d = this.isAll();
    if (d.status) {
        this.onActivate(d.data);
    }
  }
  public getNodes(id: any, parent: any, checkExport, action,node?) {
    this._isInActive = false;
    this._isActive = false;
    this._isMainTL = false;
    this._isBackupTL = false;
    this._isMutualTL = false;
    if (action !== 'all_tls') {
      this._isShowAllTls = false;
      this._isShowIconAllTls = false;
    }
    if(!this._checkExport) {
      this.ProgressLoad(() => {
        this._nodes = this.TreeItems(id, parent, (data) => {
          if (action && action == 'inactive'){
            let nodeData = data.filter(d=> d.indexElement == node.indexElement);
            this.onActivate(nodeData);
          } else this.onActivate(data);
        });
        this.setFilter(this.filterEndName, (data) => {
          if (data.length == 0) {
            this.setFilter(undefined);
          }
        })
      });
    }
  }

  public filter(value: any) {
    if ( value !== '' && value.length > 5) {
      this._nodes = this.find(this._data, value);
      this.isEmpty = (this._nodes.length === 0);
    } else {
      this._nodes = this._nodesTmp;
      this.isEmpty = false;
    }
  }
  goPrev() {
    this.ProgressLoad(() => {
      this.query.nativeElement.value = '';
      this._nodes = this.TreeItems(-1);
      this.isEmpty = false;
    });
  }
  find(data: any, value: any) {
    return data
      .filter(d => d.name.toLowerCase().indexOf(value.toLowerCase()) > -1 )
      .reverse();
  }

  private onActivate(members: any, callback?) {
    this._onactive(members, this._nodesT);
  }
  public sortBy(type?: any) {
    if (  this._nodes.length > 1) {
      this._nodes = _.sortBy(_.sortBy(this._nodes).reverse());
      this._sortStyle.transform = 'rotateX(' + ( !this._isSorted ? '180' : '0' ) + 'deg)';
      this._isSorted = !this._isSorted;
    }
  }
  public sortByField(type?: any,field?:any) {
    if (  this._nodes.length > 1) {
      if(this._isSorted){
        this._nodes = _.sortBy(this._nodes,field).reverse();
      }else{
        this._nodes = _.sortBy(this._nodes,field);
      }
      this._sortStyle.transform = 'rotateX(' + ( !this._isSorted ? '180' : '0' ) + 'deg)';
      this._isSorted = !this._isSorted;
    }
  }
  private TreeItems(id?: any, parent?: any, onActivate?) {
    const _k = this._data.filter(d => d.parent === id);
    let filter;
    parent = (typeof parent === 'undefined' ? null : parent);
    if (id === -1) {
      if (parent) {
        filter = this._data.filter(d => d.parent === parent);
        this._nodesTmp = filter;
      } else {
        filter = this.TreeItems();
        this._isShowIconAllTls = true;
      }
      return filter;
    } else {
      if (_k.length === 0) {
        if (typeof onActivate !== 'undefined') {
          onActivate(this._data.filter(d => d.id === id && d.parent == parent));
        }
        filter = this._nodesTmp;
      } else {
        let _d;
        switch (id) {
          case undefined : _d = this._data.filter(d => d.parent === undefined); break;
          default :  this._h = _d =  this._data.filter(d => d[(id === -1 ? 'id' : 'parent')] === id); break;
        }
        this._nodesTmp = _d = (_d.length === 0 ? this.TreeItems() : _d);
        filter =  _d;
      }
    }
    this.isAll();
    return filter;
  }

  private PrepareParentId()  {
    this._data.forEach((d, i) => {
      this._data.forEach((e) => {
        if (d.parent === e.id && e.parent !== undefined) {
          this._data[i].parentId = e.parent;
        }
      });
    });
  }
  private ProgressLoad(callback) {
    this.ProgressState = true;
    setTimeout(() => {
      callback();
      let t = setInterval(() => {
        if(typeof this._nodes != "undefined") {
          if(this._nodes.length > 0) {
            this.ProgressState = false;
            clearInterval(t)
          }
        }
      }, 50)
    }, 200);
  }
  public itemsData() {
    return this._data;
  }

  setFilter(el, c?) {
    const isAfterToday = e => e && moment(e.end).isSameOrAfter(TODAY);
    const isBeforeToday = e => e && moment(e.end).isSameOrBefore(TODAY);
    switch (el) {
      case undefined: this.filterEnd = ((e: any) => e) ; this.filterEndName = undefined ; break;
      case 'noend': {
        this.filterEnd = ((e: any) => {
          if(e.users && e.users.length > 0) {
           return e.users[0].periods.filter(p => p.end == null || isAfterToday(p)).length > 0
          }
        })
        this.filterEndName = 'noend';
        break;
      }
      case 'end': this.filterEnd = ((e: any) => _.pluck(e.periods , 'end').indexOf(null) == -1 || e.periods.every(p => isBeforeToday(p))); this.filterEndName = 'end'; break;
    }
    if (this._allItem) {
      const r = this._nodesTmp.filter(this.filterEnd);
      this._nodes = r;
      this.isEmpty = (this._nodes.length === 0);
      if(typeof c !='undefined') {
        c(r)
      }
    }
  }
  getNodesItemsByStatus(nodes, type: string) {
    if (nodes) {
      if (type === 'teams') {
        return nodes.filter(e => !e.parent);
      } else if (type === 'teams_tl') {
        this._isMainTL = true;
        return nodes.filter(e => (e.parent && (e.teamAssignment === 'Principale'
          || (e.isPrincipal && e.siteName === 'DEP QUALITY MADA')
          || (e.isPrincipal && e.siteName === 'DEP QM FACTORY')
          || (e.isPrincipal && e.siteName === 'DEP COMPLIANCE & RISQ')
          || (e.isPrincipal && e.siteName === 'DEP COMPLIANCE & RISK')
          || (e.isPrincipal && e.siteName === 'COMPLIANCE & RISQ')) && e.users.length > 1));
      } else if (type === 'teams_backup') {
        this._isBackupTL = true;
        return nodes.filter(e => (e.parent && (e.teamAssignment === 'Backup'
          || (!e.isPrincipal && e.siteName === 'DEP QM FACTORY')
          || (!e.isPrincipal && e.siteName === 'DEP COMPLIANCE & RISQ')
          || (!e.isPrincipal && e.siteName === 'DEP COMPLIANCE & RISK')
          || (!e.isPrincipal && e.siteName === 'COMPLIANCE & RISQ')) && e.users.length > 1));
      } else if (type === 'teams_mutualized') {
        this._isMutualTL = true;
        return nodes.filter(e => (e.parent && e.teamAssignment === 'Mutualisation' && e.users.length > 1));
      } else {
        if (nodes && type === 'inactive') {
          const res = nodes.filter(e => e.parent && (e.users && e.users.length < 2)).filter((node) => {
            if (node.users && node.users.length > 0) {
              const periods = _.sortBy(node.users[0].periods, 'start').reverse();
              const inactive = !this.isDS ? periods.length > 0 && periods[0].end != null && moment(periods[0].end).isBefore(TODAY):!node.teamName && periods.length > 0 && ((periods[0].end != null && moment(periods[0].end).isSameOrBefore(TODAY)) || (periods[0].start != null && moment(periods[0].start).isBefore(TODAY) && !periods[0].end));
              return inactive || node.users.filter(u => u.firstName.length === 0 && u.lastName.length === 0).length > 0;
            }
          });
            this._isInActive = res.length > 0;
          res.forEach((r,index)=> r.indexElement = 'row-'+index);
          return res;
        }
        if (nodes && type === 'active') {
          const res = nodes.filter(e => e.parent && (e.users && e.users.length < 2))
            .filter((node) => {
            if (node.users && node.users.length === 1 && node.users.filter(u => u.firstName.length === 0 && u.lastName.length === 0).length > 0) {
              return false;
            } else {
              if (node.users && node.users.length > 0) {
                if (node.users[0].periods) {
                  const periods = _.sortBy(node.users[0].periods, 'start').reverse();
                  const active = periods.length > 0 && (periods[0].end == null ||
                    (periods[0].end != null && moment(periods[0].end).isSameOrAfter(TODAY)));
                  return active || periods.length;
                } else {
                  return true;
                }
              }
              if (!node.users) {
                return true;
              }
            }
          });
          this._isActive = res.length > 0;
          return res;
        }
        if ( nodes && type === 'all_tls' && this._isShowAllTls) {
          if (nodes.length === 1 && nodes.filter(u => u.firstName.length === 0 && u.lastName.length === 0).length > 0) {
            return false;
          } else {
            const res = nodes.filter((node) => {
              if (node.periods) {
                const periods = _.sortBy(node.periods, 'start').reverse();
                const active = periods.length > 0 && (periods[0].end == null ||
                  (periods[0].end != null && moment(periods[0].end).isSameOrAfter(TODAY)));
                return active || periods.length;
                } else {
                  return true;
               }
              });
            this._isShowAllTls = res.length > 0;
            return res;
          }
        }
      }
    }
  }

  public getTlsOfTeams(data) {
    let users = [];
    users = data.filter(e => (e && e.class && e.class === 'persons_list' && e.users && e.users.length > 0 && e.users.filter(u => u.assignement === 'TEAM_MAIN_LEAD').length > 0 ));
    users = _.uniq(users, u => u.users[0].username);
    users.forEach(u => {
      this._tls.push({
        id: u.users[0].id,
        username: u.users[0].username,
        firstName: u.users[0].firstName,
        lastName: u.users[0].lastName,
        name: u.name,
        icon: 'person',
        parentId: u.parentId,
        parent: u.parent,
        agentName: u.agentName,
        periods: u.users[0].periods,
        villeLabel: u.villeLabel
      });
    });
  }
  public AllTeamLeaders() {
    this.getTlsOfTeams(this._data);
    this._isShowAllTls = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/view/intelcia-tree/intelcia-tree.component.ts